/**
 * Created by Kevin Dench on 6/15/2016.
 */

/* @ngInject */
export default function BreadcrumbParserService(ContainerInfoApiService, CacheService) {
    return {
        parseBreadcrumbToSentence: function (object) {
            if (object !== undefined && CacheService.getConfigurationInfo() !== undefined) {
                var breadcrumb = ContainerInfoApiService.getDisplayNameByDisplayNames(
                    object.nameBreadcrumbs,
                    CacheService.getConfigurationInfo().language
                );

                var pieces = breadcrumb.split(' -> ');
                var sentence = pieces.reverse().join(' ');

                return sentence.replace(/s$/gi, '');
            }
        },
        getImagePath: function (object) {
            const breadcrumb = object.nameBreadcrumb.toLowerCase();
            const pathArr = breadcrumb.split(' -> ');
            const strippedArr = [];
            const reSpecial = new RegExp('[^a-zA-Z0-9\-]', 'g');

            for (let i = 0; i < pathArr.length; i++) {
                strippedArr.push(pathArr[i].replace(reSpecial, '_'));
            }

            return strippedArr.join('/');
        },
        getUIBreadcrumb: function (object) {
            const breadcrumb = object.nameBreadcrumb;
            const breadArr = breadcrumb.split(' -> ');

            return breadArr.join('&nbsp;<span class=\'fa fa-caret-right\'></span>&nbsp;');
        }
    };
}
